import styled from 'styled-components';

const LogoCafeteria = styled.img`
  width: 300px;
  height: 200px;
  object-fit: cover;

  @media (max-width: 768px) {
    width: 200px;
    height: 136px;
  }
`

export { LogoCafeteria };